import Base from './Base';
import Events from '../events/Events';
import EventDispatcher from '../events/EventDispatcher';
import Tools from '../tools/Tools';
import Steps from './reservation/Steps';
import Step1 from './reservation/Step1';
import Step2 from './reservation/Step2';
import Step3 from './reservation/Step3';
import Step4 from './reservation/Step4';
import Step5 from './reservation/Step5';
import Success from './reservation/Success';
import ValidateInputs from './reservation/ValidateInputs';
import swal from 'sweetalert';
/**
 * The Reservation page.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Reservation extends Base{

	init(id,view,lang){
		console.log('Reservation :: init');

        this.view               = view;
        this.lang               = document.documentElement.getAttribute('lang');
        this.controls           = this.view.querySelector('.controls');
        this.prev               = this.controls.querySelector('.prev');
        this.next               = this.controls.querySelector('.next');
        this.$choicesParent      = this.view.querySelector('.datePicker .main');
        this.$choices           = this.$choicesParent.querySelectorAll('.datePicker .choices > label');
        this.choicesAvailable   = [];
        this.submitBt           = this.view.querySelector('button[type="submit"]');
        this.formMessage        = this.view.querySelector('.formMessage');
        this.isOka 				= false;
        this.isProcessing       = false;
        this.fireworksBypass 	= false;
        this.form               = {
            location: 0,
            extension: false,
            package: "",
            people: 0,
            option : "",
            lang: this.lang,
            date: "",
            start: ""
        }

        this.steps              = new Steps(this.view);
        this.step1              = new Step1(this.steps.steps[0]);
        this.step2              = new Step2(this.steps.steps[1]);
        this.step3              = new Step3(this.steps.steps[2]);
        this.step4              = new Step4(this.steps.steps[3], this.lang);
        this.step5              = new Step5(this.steps.steps[4]);
        this.success            = new Success(this.view.querySelector('.thx'));
        this.validateInputs     = new ValidateInputs(this.view, this.steps.steps);

        this.getURL             = this.getURL.bind(this);
        this.build              = this.build.bind(this);
        this.onCalendarDayClick = this.onCalendarDayClick.bind(this);
        this.step4.onClickEvent = this.onCalendarClick.bind(this);

        if(this.view.querySelector('.with-fireworks-bypass') && this.view.querySelector('.with-fireworks')){
        	this.view.querySelector('.with-fireworks-bypass #hardcoded_fireworks').value = this.view.querySelector('.with-fireworks input[name="city"]').value;
        }

        this.build();

    }

    build(){
        this.prev.addEventListener('click', this.goPrev.bind(this));
        this.next.addEventListener('click', this.goNext.bind(this));

        this.step1.inputs.forEach(input => {
            input.addEventListener('change', ()=>{
                this.form.location = input.value;

                if(input.parentNode.parentNode.classList.contains('with-fireworks-bypass'))
        			this.fireworksBypass = true;
        		else
        			this.fireworksBypass = false;
            });
        });

        this.step2.dec.addEventListener('click', ()=>{
            if(this.step2.decrease())
                this.form.people = this.step2.current;
        });
        this.step2.inc.addEventListener('click', ()=>{
            if(this.step2.increase())
                this.form.people = this.step2.current;
        });

        //calendar
        this.$choices.forEach((choice,index) =>{
            choice.addEventListener('click', (e) =>{
            	this.onCalendarDayClick(e,index);
            });
        });

        this.submitBt.addEventListener('click', this.step5.submitForm);

        window.addEventListener(Events.Checkout.RETRIEVED_KEY, this.initStripe.bind(this));
        window.addEventListener(Events.Checkout.SUCCESS, this.checkoutSuccess.bind(this));
        window.addEventListener(Events.Form.SUCCESS, this.formSuccess.bind(this));
        window.addEventListener(Events.Form.ERROR, this.formError.bind(this));
    }

    initStripe(data){
        //Stripe mounting
        // this.stripe         = Stripe('pk_test_AbX9RYJZi3eXIdp7dTRCpFHx');
        this.stripe         = Stripe(data.detail);
        const elements      = this.stripe.elements({
            locale:this.lang
        });
        this.cardNumber    = elements.create('cardNumber');
        this.cardExpiry    = elements.create('cardExpiry');
        this.cardCvc       = elements.create('cardCvc');
        this.cardName      = this.view.querySelector('#card_name');

        this.cardNumber.mount('#form_card_number');
        this.cardExpiry.mount('#form_card_expiry');
        this.cardCvc.mount('#form_card_cvv');
    }

    checkoutSuccess(e){
        let checkoutForm = e.detail;

        this.stripe.createToken(this.cardNumber, {name: this.cardName.value}).then((result)=> {
            if(result.token){
                this.formMessage.classList.add('hidden');
                //merge
                Object.assign(this.form, checkoutForm);

                this.form.token = result.token.id;
                this.success.cardBrand = result.token.card.brand;
                this.success.card4LastNumb = result.token.card.last4;
                this.sendCheckoutInfos();
            }else{
                this.formMessage.classList.remove('hidden');
                this.formMessage.innerHTML = result.error.message;
                document.querySelector('.container').classList.remove('load');
            }
        });

    }

    compileParams(data){
        let response = [];

        Object.keys(data).forEach(prop =>{
            response.push(prop + '=' + data[prop]);
        });

        return response.join('&');
    }

    formSuccess(response){
        console.log(response);

        if(response.detail.success){
            this.goNext(null,true);
            this.success.load(response.detail);
        }else{
            this.formMessage.classList.remove('hidden');
            this.formMessage.innerHTML = response.detail.message;
        }
    }

    formError(response){
    	console.log(response);

	    this.formMessage.classList.remove('hidden');
	    this.formMessage.innerHTML = response.detail.message;
    }

    getURL(myUrl){
        if(!this.isProcessing){
            this.isProcessing = true;
            document.querySelector('.container').classList.add('load');
            const xhr = new XMLHttpRequest();
            xhr.open('GET', myUrl, true);
            xhr.onreadystatechange = this.xhrEvent.bind(this);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send();
        }

    }

    goNext(e,last = false){

        if(this.validateInputs.validateStep(this.steps.current)) {
        	console.log("current step :: ",this.steps.current);
            if(this.steps.current == 0) {

                let myUrl = 'wp-admin/admin-ajax.php?action=location_packages&lang='+this.lang+'&id='+this.form.location;
                this.getURL(myUrl);

                if(document.querySelector('label[for="city-'+this.form.location+'"] .city').innerHTML == 'Oka') this.isOka = true;
                else this.isOka = false;

            }else if(this.steps.current == 1) {
                this.form.people = this.step2.current;

                //check if still fireworks
                this.step2.inputs.forEach(input => {
                    if(input.checked && input.classList.contains('fireworks')){
                    	this.fireworksBypass = true;
                    	return;
                    }

                	this.fireworksBypass = false;
                });

                let myUrl = 'wp-admin/admin-ajax.php?action=package_options&lang='+this.lang+'&package='+this.form.package+'&passengers='+this.form.people+'&location='+this.form.location;
                this.getURL(myUrl);

            }else if(this.steps.current == 2) {
            	console.log(this.isOka);
            	this.step4.load(this.form.location, this.form.option, this.firstDay, this.form.extension, this.form.package, this.isOka);
            }

            if(last){
                this.controls.remove();
                this.view.querySelector('.stepBar').remove();
                this.steps.next(last);
            }else {
                this.controls.classList.remove('hidden');
                this.steps.next();
            }

            if(this.steps.current == 3 || this.steps.current == 4) this.next.classList.add('hide');
            else this.next.classList.remove('hide');

            console.log("FORM: ",this.form);
        }
        else{
        	if(this.steps.current != 1){
	            swal({
	              title: this.lang == "en" ? "Error !" : "Erreur !",
	              text: this.lang == "en" ? 'One or more options were not properly filled' : 'Une ou plusieurs options n\'ont pas été correctement remplies',
	              icon: "error",
	            });
        	}else{
        		swal({
        		  title: this.lang == "en" ? "Error !" : "Erreur !",
        		  text: this.lang == "en" ? 'One or more options were not properly filled. Make sure you have chosen the number of people!' : 'Une ou plusieurs options n\'ont pas été correctement remplies. Assurez-vous d\'avoir choisit le nombre de personnes!',
        		  icon: "error",
        		});
        	}
        }

    }

    goPrev(){
        this.steps.prev();
    }

    onCalendarClick(calEvent, jsEvent, view){

        let myUrl = 'wp-admin/admin-ajax.php?action=calendar_day_information&lang='+this.lang+'&date='+calEvent.start._i+'&location='+this.form.location+'&extension='+this.form.extension+"&package="+this.form.package
    	this.selectedDate = calEvent.start;
        this.getURL(myUrl);

        for(let i = 0; i < this.$choices.length; i++)
        	this.$choices[i].classList.add('hidden');
    }
    onCalendarDayClick(e,index){
        if(!e.currentTarget.classList.contains('disabled') && this.choicesAvailable[index].available){
        	//prevent if someone one changes DOM
        	if(this.choicesAvailable[index].event && this.choicesAvailable[index].event == 'fireworks') {
        		return;
        	}

            this.goNext();
            this.form.date = e.currentTarget.getAttribute('data-date');
            this.form.start = e.currentTarget.getAttribute('data-start');

            let myUrl = 'wp-admin/admin-ajax.php?action=get_total&lang='+this.lang+'&location='+this.form.location+'&option='+this.form.option+'&package='+this.form.package+'&people='+this.form.people+'&extension='+this.form.extension+'&date='+this.form.date+'&start='+this.form.start;
            this.getURL(myUrl);
        }
    }

    onCompleteCheckout(response){
        console.log("ValidateCheckout :: onCompleteCheckout :: ",response);
       document.querySelector('.container').classList.remove('load');
        if(response){
           EventDispatcher.trigger(window, Events.Form.SUCCESS, true, true, response);
        }else console.error('ValidateCheckout :: response.success == false');
    }

    onCompleteEvent(response){
        console.log(response);

        Tools.scrollTo(0,$(this.view.querySelector('.container')).offset().top - 40);

        if(response && response.success){
        	this.view.querySelector('.datePicker_content .main').classList.remove('phone');

            if(response.data){
            	this.view.querySelector('.state').checked = true;

                this.choicesAvailable = response.data;

                for(let i = 0; i < this.choicesAvailable.length; i++){
                    this.$choices[i].querySelector('.time').innerHTML = this.choicesAvailable[i].label;
                    this.$choices[i].setAttribute('data-start', this.choicesAvailable[i].start);
                    this.$choices[i].setAttribute('data-date', response.date.raw);

                    if(!this.choicesAvailable[i].available) this.$choices[i].classList.add('disabled');
                    else {
                        this.$choices[i].classList.remove('disabled');

                        if(this.choicesAvailable[i].event == "sunset") this.$choices[i].querySelector('.sunset').classList.add('active');
                        else this.$choices[i].querySelector('.sunset').classList.remove('active');

                        if(this.choicesAvailable[i].event == "fireworks") {
                        	this.$choices[i].querySelector('.fireworks').classList.add('active');
                        	this.$choices[i].classList.add('caller');
                        }
                        else {
                        	this.$choices[i].querySelector('.fireworks').classList.remove('active');
                        	this.$choices[i].classList.remove('caller');
                        }
                    }

                    this.$choices[i].classList.remove('hidden');
                }

                console.log('available choices :: ',this.choicesAvailable);

                // if(this.choicesAvailable.length == 2) {
                //     this.$choices[2].classList.add('hidden');
                //     this.$choices[1].classList.remove('hidden');
                //     this.$choices[0].classList.remove('hidden');
                //     // this.$choices[0].parentNode.classList.add('extend');
                //     // this.$choices[0].parentNode.classList.remove('solo');
                // }
                // else if(this.choicesAvailable.length == 1) {
                //     this.$choices[0].classList.remove('hidden');
                //     this.$choices[1].classList.add('hidden');
                //     this.$choices[2].classList.add('hidden');
                //     // this.$choices[0].parentNode.classList.add('extend');
                //     // this.$choices[0].parentNode.classList.add('solo');
                // }
                // else {
                //     // this.$choices[0].parentNode.classList.remove('solo');
                //     this.$choices[1].classList.remove('hidden');
                //     this.$choices[2].classList.remove('hidden');
                //     // this.$choices[0].parentNode.classList.remove('extend');
                // }

                // if(this.fireworksBypass){
                // 	this.$choices[0].classList.add('hidden');
                // 	this.$choices[1].classList.add('hidden');

                // 	// if(this.$choices[0] && !this.$choices[0].available && this.$choices[1] && !this.$choices[1].available)
                //     	// this.$choices[0].parentNode.classList.add('solo');
                //     // else if (this.$choices[0] && this.$choices[0].available)

                // }

                this.$choicesParent.querySelector('.title span').innerHTML = response.date.formatted;

            }else if(response.packages){
                this.currency = response.currency;
                this.firstDay = response.start;
                this.step2.load(response);

                this.step2.inputs.forEach(input => {
                    input.addEventListener('change', ()=>{
                        this.step2InputOnChange(input);
                    });
                });

                if(this.fireworksBypass){
                	let inputs = this.step2.view.querySelectorAll('input');

	            	for(let i = 0; i < inputs.length; i++){
            			if(inputs[i].classList.contains('fireworks')){
            				this.step2.number.innerHTML = this.step2.current = 8;
            				this.step2InputOnChange(inputs[i]);
            				inputs[i].checked = true;
            				this.isProcessing = false;
            				this.goNext();
        				}
    				}
	            }

            }else if(response.options){
                this.step3.load(response, this.form.people, this.currency);

                this.step3.inputs.forEach(input => {
                    input.addEventListener('change', ()=>{
                        let id = input.id;
                        this.form.option = id.replace(/[^0-9]/g, '');
                    });
                });

                if(this.fireworksBypass){
            		this.step3.inputs[0].checked = true;
            		this.form.option = this.step3.inputs[0].id.replace(/[^0-9]/g, '');
            		this.isProcessing = false;
            		this.goNext();
                }


            }else if(response.totals){
                this.step5.load(response, this.currency);

            }
        }else{
        	this.view.querySelector('.state').checked = true;
        	this.view.querySelector('.datePicker_content .main').classList.add('phone');
        	this.view.querySelector('.datePicker_content .main .title span').innerHTML = response.date.formatted;
        }

        document.querySelector('.container').classList.remove('load');
        this.isProcessing = false;
    }

    onRSC(event){
        // Request is not ready yt
        const xhr = event.target;

        if(xhr.readyState != XMLHttpRequest.DONE)
            return;

        try{
            const data = JSON.parse(xhr.responseText);
            this.onCompleteCheckout(data);
            this.sending = false;

        }catch(e){ console.error('ValidateCheckout :: onRSC :: error ::', e); }
    }

    sendCheckoutInfos(){
        console.log("ValidateCheckout :: sendCheckoutInfos");
        if(!this.sending){
            this.sending = true;
            document.querySelector('.container').classList.add('load');
            const xhr = new XMLHttpRequest();
            xhr.open('POST', 'wp-admin/admin-ajax.php?action=reservation', true);
            xhr.onreadystatechange = this.onRSC.bind(this);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(this.compileParams(this.form));
        }else console.log('ValidateCheckout :: was already sending');
    }

    step2InputOnChange(input){
        let id = input.id;
        let idSplited = id.split('_');
        this.form.package   = idSplited[1];
        this.form.extension = idSplited[2];
        this.step2.max      = input.getAttribute('data-max');
        if(Number(this.step2.max) != Number(this.step2.people.innerHTML)) this.step2.updatePeople();
        if(Number(this.step2.current) > Number(this.step2.max)) this.step2.updateMax();
    }

    xhrEvent(event){
        const xhr = event.target;
        if(xhr.readyState != XMLHttpRequest.DONE)
            return;

        try{
            const data = JSON.parse(xhr.responseText);
            this.onCompleteEvent(data);

        }catch(e){ console.error('EventStateChange :: error ::', e); }
    }

}